import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'

import { P } from '@mxenabled/mxui'

import { CategorySelectorDrawer } from '../../../../categories'

import { Dialog, useCategoryStore, useGlobalCopyStore } from '../../../../common'
import type { Transaction } from '../../../../core'

import { useTransactionStore } from '../../../../common'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

interface EditCategoryActionProps {
  onClose: () => void
  transaction: Transaction
}

const EditCategoryAction: React.FC<EditCategoryActionProps> = ({ onClose, transaction }) => {
  const { addOrUpdateTransactionRule, updateTransaction } = useTransactionStore()
  const { transactions: copy } = useGlobalCopyStore()

  const { categories } = useCategoryStore()

  const [categoryGuid, setCategoryGuid] = React.useState('')

  const category = React.useMemo(
    () => categories.find((item) => item.guid === categoryGuid),
    [categoryGuid],
  )

  const handleCategoryChanged = async (applyToAll: boolean) => {
    await updateTransaction({ ...transaction, category_guid: categoryGuid })
    if (applyToAll) {
      await addOrUpdateTransactionRule(categoryGuid, transaction)
    }

    setCategoryGuid('')
    onClose()
  }

  return (
    <Box className="mx-txn-edit-category-action">
      <CategorySelectorDrawer
        initialSelected={transaction.category_guid}
        onClose={onClose}
        onSelect={(guid: string) => setCategoryGuid(guid)}
        showDrawer={!!transaction}
        title={copy.actions_select_a_category}
      />
      <Dialog
        copy={{
          title: buildDynamicCopy(
            copy.actions_apply_to_all_transaction_types,
            transaction.description,
          ) as string,
        }}
        isOpen={!!categoryGuid}
        onClose={() => handleCategoryChanged(false)}
        onPrimaryAction={() => handleCategoryChanged(true)}
        onSecondaryAction={() => handleCategoryChanged(false)}
        primaryText={copy.actions_apply_to_all}
        secondaryText={copy.actions_this_time_only}
      >
        <P variant="subtitle1">
          {
            buildDynamicCopy(
              copy.actions_all_past_and_future,
              transaction.description,
              category?.name,
            ) as string
          }
        </P>
      </Dialog>
    </Box>
  )
}

export default observer(EditCategoryAction)
